import React, { memo, useCallback, useEffect, useRef } from 'react';
import { ScrollWrapper } from './Scroll.Styles';
import { useScroll, scrollActions } from '../../../ModuleApp';
import { usePage } from '../../';
export var Scroll = memo(function (_a) {
    var children = _a.children;
    var dispatchScroll = useScroll().dispatchScroll;
    var pageId = usePage().pageId;
    var refScroller = useRef(null);
    useEffect(function () { var _a; return (_a = refScroller.current) === null || _a === void 0 ? void 0 : _a.scrollTo(0, 0); }, [pageId]);
    var onScroll = useCallback(function (event) {
        return dispatchScroll({ type: scrollActions.SET, payload: event.currentTarget.scrollTop });
    }, [dispatchScroll]);
    return (React.createElement(ScrollWrapper, { ref: refScroller, onScroll: onScroll }, children));
});
